import React from 'react';
import Spinner from 'react-spinkit';
// import '../styles/Loading.css';

function Loading() {
  return <div style={{ padding: '2rem', textAlign: 'center' }}><div style={{ display: 'inline-block' }}><Spinner name="double-bounce" color="#001457" /></div></div>;
}

export default Loading;
